import script from "./NoteEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./NoteEditor.vue?vue&type=script&lang=ts&setup=true"

import "./NoteEditor.vue?vue&type=style&index=0&id=922c4222&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-922c4222"]])

export default __exports__